<div id="actionButtonsContainer" class="flexRowContainer">
  <button mat-icon-button (click)="backToCase()" (keydown.enter)="backToCase()"
          aria-label="Back to case">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
  </button>
</div>
<div id="completeCaseContainer" class="flexColumnContainer">
  <p class="headline-small">{{ 'completeCase.title' | translate }}</p>
  <div id="defaultCompleteMessage">
    <p class="body-large">{{ 'completeCase.defaultCompleteMessage' | translate }}</p>
  </div>
  <div id="personalMessageContainer" class="inputContainer">
    <div class="flexRowContainer">
      <mat-expansion-panel class="flexColumnContainer"
                           [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="title-medium">
            <mat-icon class="material-symbols-outlined stepIcon">chat</mat-icon>
            {{ 'completeCase.addPersonalMessage.title' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="body-medium">{{ 'completeCase.addPersonalMessage.description' | translate }}</p>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'completeCase.addPersonalMessage.label' | translate }}</mat-label>
          <textarea matInput placeholder="{{ 'completeCase.addPersonalMessage.placeholder' | translate }}"
                    aria-label="Comment"
                    [formControl]="commentFormControl"></textarea>
        </mat-form-field>
      </mat-expansion-panel>
    </div>
  </div>
  <div id="actionsContainer" class="flexRowContainer inputContainer">
    <button
      mat-flat-button
      (click)="completeCase()"
      (keydown.enter)="completeCase()"
    >
      {{ 'completeCase.actions.completeCase' | translate }}
    </button>
  </div>
</div>

